<template>
  <div class="d-flex justify-end mx-3 mt-3" v-if="isClubManager">
    <v-icon @click="edit = !edit" color="primary" size="40" >{{ edit ? 'mdi-arrow-u-left-top' : 'mdi-pencil' }}</v-icon>
  </div>

  <v-list v-if="!edit" density="compact">
    <v-list-item>
      <v-list-item-title class="d-inline">{{ $t('club.club_about.name') }}:</v-list-item-title>
      {{ props.club.club_name }}
    </v-list-item>
    <v-list-item>
      <v-list-item-title class="d-inline">{{ $t('club.club_about.country') }}:</v-list-item-title>
      {{ props.club.club_country }}
    </v-list-item>
    <v-list-item>
      <v-list-item-title class="d-inline">{{ $t('club.club_about.currency') }}:</v-list-item-title>
      {{ props.club.club_currency }}
    </v-list-item>
    <v-list-item>
      <v-list-item-title class="d-inline">{{ $t('club.club_about.address') }}:</v-list-item-title>
      {{ props.club.address }}
    </v-list-item>
    <v-list-item>
      <v-list-item-title class="d-inline">{{ $t('club.club_about.email') }}:</v-list-item-title>
      {{ props.club.email }}
    </v-list-item>
    <v-list-item>
      <v-list-item-title class="d-inline">{{ $t('club.club_about.www') }}:</v-list-item-title>
      {{ props.club.www }}
    </v-list-item>
    <v-list-item>
      <v-list-item-title class="d-inline">{{ $t('club.club_about.tel') }}:</v-list-item-title>
      {{ props.club.tel }}
    </v-list-item>
    <v-list-item>
      <v-list-item-title class="d-inline">{{ $t('club.club_about.ic') }}:</v-list-item-title>
      {{ props.club.ic }}
    </v-list-item>
  </v-list>
  <v-form v-else ref="formRef" v-model="formValid">
    <v-text-field v-model="localClub.address" :label="$t('club.club_about.address')" maxlength="80" counter />
    <v-select :label="$t('club.club_about.currency')" v-model="localClub.club_currency" :items="CURRENCY_ITEMS"></v-select>
    <v-text-field v-model="localClub.email" :label="$t('club.club_about.email')" :rules="emailRules" maxlength="40" counter />
    <v-text-field v-model="localClub.www" :label="$t('club.club_about.www')" maxlength="50" counter />
    <v-text-field v-model="localClub.tel" :label="$t('club.club_about.tel')" maxlength="14" counter />
    <v-text-field v-model="localClub.ic" type="number" :label="$t('club.club_about.ic')" />
    <div class="d-flex justify-end">
      <v-btn @click="submitAboutClub" :disabled="!formValid" color="success">{{ $t('general.save') }}</v-btn>
    </div>
  </v-form>
  
</template>
<script setup>

import { ref, reactive, watch } from 'vue';
import {useSnackbarStore} from '@/stores/snackbarStore'
import apiClient from '/api.js';
import { useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { CURRENCY_ITEMS} from '@/components/const/enums.js';




const props = defineProps({
  club: {
    type: Object,
    required: true
  },
  isClubManager: {
    type: Boolean,
    default: false
  },
  assistUser: {
    type: Object,
    default: null
  }
});

const { t } = useI18n();
const emit = defineEmits(['fetchClub']);


const snackbar = useSnackbarStore()
const route = useRoute();



const emailRules = [ v => !v || /.+@.+\..+/.test(v) || t('general.invalid_email'),];
const formValid = ref(false);

const edit = ref(false);
const club_shortcut = ref(route.params.id);

const localClub = reactive({ ...props.club });

// Synchronizace props s lokální kopií, když se props změní
watch(() => props.club, (newClub) => {
  Object.assign(localClub, newClub);
});

const submitAboutClub = async () => {
  try {

    await apiClient.put(`/club/?club_shortcut=${club_shortcut.value}`, {
      club_name: localClub.club_name,
      club_country: localClub.club_country,
      club_currency: localClub.club_currency,
      address: localClub.address,
      email: localClub.email,
      www: localClub.www,
      tel: localClub.tel,
      ic: localClub.ic
    }); 

    emit("fetchClub");
    snackbar.success(t('club.club_about.updated'));
    
  } catch (error) {
    snackbar.error(t('club.club_about.error'));
  }

}


</script>

<style scoped>


  .v-list-item-title {
    font-weight: bold;
  }

</style>